import React from 'react';
import { BookOpen, Brain, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { Theme } from '../types';

interface LogoProps {
  theme: Theme;
  size?: 'small' | 'medium' | 'large';
}

export default function Logo({ theme, size = 'medium' }: LogoProps) {
  const sizes = {
    small: {
      container: 'h-8 w-8',
      icon: 16,
      sparkle: 12
    },
    medium: {
      container: 'h-12 w-12',
      icon: 24,
      sparkle: 18
    },
    large: {
      container: 'h-16 w-16',
      icon: 32,
      sparkle: 24
    }
  };

  return (
    <motion.div
      initial={{ rotate: -10 }}
      animate={{ rotate: 0 }}
      whileHover={{ scale: 1.1, rotate: -5 }}
      className={`relative ${sizes[size].container}`}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <BookOpen
          size={sizes[size].icon}
          className={theme === 'dark' ? 'text-purple-400' : 'text-purple-600'}
        />
      </div>
      <div className="absolute inset-0 flex items-center justify-center opacity-70">
        <Brain
          size={sizes[size].icon}
          className={theme === 'dark' ? 'text-purple-500' : 'text-purple-700'}
        />
      </div>
      <Sparkles
        size={sizes[size].sparkle}
        className={`absolute -top-1 -right-1 ${
          theme === 'dark' ? 'text-purple-300' : 'text-purple-500'
        }`}
      />
    </motion.div>
  );
}